// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CrownFilledSvg from "@ant-design/icons-svg/es/asn/CrownFilled";
import AntdIcon from '../components/AntdIcon';

var CrownFilled = function CrownFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CrownFilledSvg
  }));
};

CrownFilled.displayName = 'CrownFilled';
export default React.forwardRef(CrownFilled);